package com.iptvplayer.shared.domain.model

/**
 * Outcome of a catalog sync. Success no longer means "every source loaded" —
 * it means the sync ran; per-source failures are reported here so clients can
 * tell the user *why* content is missing instead of showing a silent empty UI.
 */
data class SyncReport(
    val sourceCount: Int,
    val failures: List<SourceFailure> = emptyList(),
    /** True when the catalog was served from the local cache without touching the network. */
    val fromCache: Boolean = false
) {
    val allFailed: Boolean get() = sourceCount > 0 && failures.size == sourceCount
}

/** One IPTV source that failed to load, with a classified, user-explainable reason. */
data class SourceFailure(
    val sourceName: String,
    val kind: Kind,
    /** Raw detail (exception message / HTTP status) for logs or expanded views. */
    val detail: String? = null
) {
    enum class Kind {
        /** The provider's server is down or answering with server errors (5xx). */
        PROVIDER_DOWN,
        /** The provider rejected this source's credentials (401/403). */
        AUTH_FAILED,
        /** The provider couldn't be reached at all — connectivity, DNS, timeout. */
        NETWORK,
        UNKNOWN
    }
}
